var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Link, LinkSession } from 'anchor-link';
import BrowserTransport from 'anchor-link-browser-transport';
var AnchorLinkProvider = /** @class */ (function () {
    function AnchorLinkProvider(link, sessionId, storage) {
        var _this = this;
        this.id = 'anchor-link';
        this.meta = {
            name: 'Anchor Link',
            shortName: 'Anchor Link',
            description: 'Use Anchor (or any other ESR compatible wallet) to sign transactions'
        };
        this.signatureProvider = {
            getAvailableKeys: function () {
                if (!_this.sessionProvider) {
                    throw new Error('Not logged in');
                }
                return _this.sessionProvider.getAvailableKeys();
            },
            sign: function (args) {
                if (!_this.sessionProvider) {
                    throw new Error('Not logged in');
                }
                return _this.sessionProvider.sign(args);
            }
        };
        this.link = link;
        this.sessionId = sessionId;
        this.storage = storage;
    }
    AnchorLinkProvider.prototype.connect = function () {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    };
    AnchorLinkProvider.prototype.disconnect = function () {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    };
    AnchorLinkProvider.prototype.discover = function () {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    };
    AnchorLinkProvider.prototype.signArbitrary = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error('signArbitrary not supported');
            });
        });
    };
    AnchorLinkProvider.prototype.login = function (accountName, authorization, index, key) {
        return __awaiter(this, void 0, void 0, function () {
            var session, existing, loginResult, auth;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.storage.restore(this.link, this.sessionId, accountName)];
                    case 1:
                        existing = _a.sent();
                        if (!existing) return [3 /*break*/, 2];
                        session = existing;
                        return [3 /*break*/, 5];
                    case 2: return [4 /*yield*/, this.link.login(this.sessionId)];
                    case 3:
                        loginResult = _a.sent();
                        session = loginResult.session;
                        return [4 /*yield*/, this.storage.store(session, this.sessionId, accountName)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        this.session = session;
                        this.sessionProvider = session.makeSignatureProvider();
                        auth = {
                            accountName: session.auth.actor,
                            permission: session.auth.permission,
                            publicKey: session.publicKey
                        };
                        return [2 /*return*/, auth];
                }
            });
        });
    };
    AnchorLinkProvider.prototype.logout = function (accountName) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.storage.remove(this.sessionId, accountName)];
                    case 1:
                        _a.sent();
                        this.session = undefined;
                        this.sessionProvider = undefined;
                        return [2 /*return*/];
                }
            });
        });
    };
    return AnchorLinkProvider;
}());
var LocalSessionStorage = /** @class */ (function () {
    function LocalSessionStorage(keyPrefix) {
        if (keyPrefix === void 0) { keyPrefix = 'anchorlink'; }
        this.keyPrefix = keyPrefix;
    }
    LocalSessionStorage.prototype.sessionKey = function (id, accountName) {
        return [this.keyPrefix, id, accountName]
            .filter(function (v) { return typeof v === 'string' && v.length > 0; })
            .join('-');
    };
    LocalSessionStorage.prototype.store = function (session, id, accountName) {
        return __awaiter(this, void 0, void 0, function () {
            var key, data;
            return __generator(this, function (_a) {
                key = this.sessionKey(id, accountName);
                data = session.serialize();
                localStorage.setItem(key, JSON.stringify(data));
                return [2 /*return*/];
            });
        });
    };
    LocalSessionStorage.prototype.restore = function (link, id, accountName) {
        return __awaiter(this, void 0, void 0, function () {
            var key, data;
            return __generator(this, function (_a) {
                key = this.sessionKey(id, accountName);
                data = JSON.parse(localStorage.getItem(key) || 'null');
                if (data) {
                    return [2 /*return*/, LinkSession.restore(link, data)];
                }
                return [2 /*return*/, null];
            });
        });
    };
    LocalSessionStorage.prototype.remove = function (id, accountName) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                localStorage.removeItem(this.sessionKey(id, accountName));
                return [2 /*return*/];
            });
        });
    };
    return LocalSessionStorage;
}());
export default function makeProvider(sessionId, options) {
    if (options === void 0) { options = {}; }
    return function (network) {
        var resolvedOptions;
        if (!options.transport) {
            resolvedOptions = __assign({}, options, { transport: new BrowserTransport(options) });
        }
        else {
            resolvedOptions = options;
        }
        var link = new Link(__assign({}, resolvedOptions, { chainId: network.chainId, rpc: network.protocol + '://' + network.host + ':' + network.port }));
        var storage = options.sessionStorage || new LocalSessionStorage();
        return new AnchorLinkProvider(link, sessionId, storage);
    };
}
//# sourceMappingURL=index.js.map